import useCollectorPermissions from "./useCollectorPermissions";
const useCanAccessDeployment = () => {
  const { canDeployCollectors, canViewEnrollmentTokens } = useCollectorPermissions();
  return canDeployCollectors || canViewEnrollmentTokens;
};
export default useCanAccessDeployment;
